'use client'

import { useTranslations } from 'next-intl'
import { useLayoutEffect } from 'react'

import { getCookie, setCookie, useSession } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

const COOKIE_NAME = 'email-sent-dialog'
const POPUP_COOKIE_VALUE = 'hide'

const getExpireTime = () => {
  return new Date(Date.now() + 1000 * 60 * 60 * 24) // 1 day
}

type Props = {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const EmailSentUserDialog = ({ isOpen, onOpen, onClose }: Props) => {
  const session = useSession()

  const t = useTranslations('email_verification_required')

  const handleOpenChange = (open?: boolean) => {
    if (open) return

    if (isOpen) {
      setCookie(COOKIE_NAME, POPUP_COOKIE_VALUE, {
        expires: getExpireTime(),
      })
    }

    onClose()
  }

  useLayoutEffect(() => {
    if (session.data?.verificationStatus !== 'EMAIL_SENT') return

    const isHiddenForDay = getCookie(COOKIE_NAME) === POPUP_COOKIE_VALUE

    if (!isHiddenForDay) {
      onOpen()
    }
  }, [session])

  return (
    <AlertDialog
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      title={t('dialog_title')}
      content={t('dialog_description', {
        email: session.data?.email || '',
      })}
      preventOutsideClick
    />
  )
}
